import setedigitalApi from "./api/setedigitalApi";

export const fetchUser = async () => {
  try {
    const response = await setedigitalApi.get("/user/me");
    return response.data;
  } catch (error) {
    throw error;
  }
};
